/* global axios */
import ApiClient from "dashboard/api/ApiClient";

class CRMStagesAPI extends ApiClient {
  constructor() {
    super("crm/stages", { accountScoped: true });
  }

  get(pipelineId) {
    return axios.get(`${this.baseUrl()}/crm/pipelines/${pipelineId}/stages`);
  }

  show(pipelineId, stageId) {
    return axios.get(`${this.baseUrl()}/crm/pipelines/${pipelineId}/stages/${stageId}`);
  }

  create(pipelineId, stageData) {
    return axios.post(`${this.baseUrl()}/crm/pipelines/${pipelineId}/stages`, {
      crm_stage: stageData,
    });
  }

  update(pipelineId, stageId, stageData) {
    return axios.patch(`${this.baseUrl()}/crm/pipelines/${pipelineId}/stages/${stageId}`, {
      crm_stage: stageData,
    });
  }

  delete(pipelineId, stageId) {
    return axios.delete(`${this.baseUrl()}/crm/pipelines/${pipelineId}/stages/${stageId}`);
  }

  reorder(pipelineId, direction, stageId) {
    return axios.post(`${this.baseUrl()}/crm/pipelines/${pipelineId}/stages/reorder`, {
      direction,
      stage_id: stageId
    });
  }
}

export default new CRMStagesAPI();
